// React
import React, { useState } from 'react';

// Packages
import { Outlet } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';

import { grey } from '@mui/material/colors';

import NavigationDrawer from '../../components/Navigation/NavigationDrawer/index.js';
import NavigationHeaderBar from '../../components/Navigation/NavigationHeaderBar/index.js';

const Navigation = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  return (
    <div>
      <NavigationHeaderBar handleDrawerToggle={handleDrawerToggle} />
      <NavigationDrawer isMobile={isMobile} isMobileOpen={isMobileOpen} setIsMobileOpen={setIsMobileOpen} handleDrawerToggle={handleDrawerToggle} />
      <main style={{ backgroundColor: grey[100], height: '100vh', marginLeft: isMobile ? 0 : 280 }}>
        <Outlet />
      </main>
    </div>
  );

}

export default Navigation
